export default __webpack_public_path__ + "static/media/expl-dissect_12_EN.60209f3a.png";